
import { Calendar } from "@/models/calendar";
import { CalendarService } from "@/services";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return  {
			fetchedCalendars: CalendarService.cachedCalendars as Calendar[]
		};
	},
	props: {
		value: {
			type: Number
		},
		fancy: Boolean,
		label: {
			type: [String, Object as ()=> TranslateResult]
		}
	},
	computed: {
		calendarItems(): ISelectItem<number>[] {
			let cals = this.fetchedCalendars;
			return cals.map((c: Calendar) => {
				return {
					text: c.Name,
					value: c.ID,
					color: c.Color
				};
			});
		}
	},
	async mounted() {
		this.fetchedCalendars = await CalendarService.getCalendars();
		if (this.fetchedCalendars.length > 0 && this.value == 0){
			this.$emit("input", this.fetchedCalendars[0].ID);
		}
	},
});
